module.exports = __webpack_public_path__ + "img/bringer.0e46f084.jpg";